import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { deleteFavorisQuote } from 'redux/actions/quoteActions';
import FavoritesQuotes from './FavoritesQuotes';

const mapStateToProps = ({ layout }) => {
    const { locale, userData } = layout;
    return {
        locale,
        userData: userData.data,
    };
};

export default withRouter(connect(mapStateToProps, { deleteFavorisQuote })(FavoritesQuotes));
